<template>
  <div v-if="count != 999" class="seat">
    <span :class="{ none: under10, little: between10_99, yes: over100 }">
      {{ seatName }}
      <span v-if="seatName == 'サルーン'">（{{ count }}ボックス)</span>
      <span v-else-if="seatName != '一般席'">（{{ count }}席)</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "MFITTSeatVacant",
  props: {
    seatName: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  computed: {
    over100() {
      if (this.seatName == "一般席") {
        return this.count >= 100;
      } else {
        return this.count >= 1;
      }
    },
    between10_99() {
      if (this.seatName == "一般席") {
        return 100 > this.count && this.count > 9;
      } else {
        return false;
      }
    },
    under10() {
      if (this.seatName == "一般席") {
        return 9 >= this.count;
      } else {
        return this.count == 0 || this.count == 999;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.train-list .list-body .buttons .button .seat {
  display: block;
  padding: 0;
  margin: 0 0 8px;
}
.train-list .list-body .buttons .button .seat .status {
  display: inline-block;
  width: 14px;
  width: auto;
  padding: 0;
  margin: 10px 0 0;
}
.train-list .list-body .buttons .button .seat span.yes,
.train-list .list-body .buttons .button .seat span.little,
.train-list .list-body .buttons .button .seat span.none {
  font-size: 13px;
  line-height: 13px;
  padding: 0;
}
.train-list .list-body .buttons .button .seat span.yes::before,
.train-list .list-body .buttons .button .seat span.little::before,
.train-list .list-body .buttons .button .seat span.none::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0 6px 0 0;
}
.train-list .list-body .buttons .button .seat span.yes::before {
  background: url("~@/assets/img/icon/svg/icon-yes.svg") no-repeat;
  background-position: 0 4px;
}
.train-list .list-body .buttons .button .seat span.little::before {
  background: url("~@/assets/img/icon/svg/icon-little.svg") no-repeat;
  background-position: 0 4px;
}
.train-list .list-body .buttons .button .seat span.none::before {
  background: url("~@/assets/img/icon/svg/icon-none.svg") no-repeat;
  background-position: 0 4px;
}
</style>
